import React from 'react';
import { FaArrowDown,FaInstagram } from 'react-icons/fa';
import { GiTooth } from "react-icons/gi"; 
const Hero = () => {

  const handleSubmit = (e) => {
    e.preventDefault();

    const phoneNumber = process.env.REACT_APP_PHONE_NUMBER; // <-- WhatsApp number in international format

    const message = `Bonjour, je veux prendre un rendez-vous pour une consultation.`;

    const encodedMessage = encodeURIComponent(message);

    window.open(
      `https://wa.me/${phoneNumber}?text=${encodedMessage}`,
      "_blank"
    );
  };

  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-primary-50 to-secondary-50 overflow-hidden"
    >
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <GiTooth className="absolute top-20 left-20 text-primary-300 w-32 h-32" />
        <GiTooth className="absolute bottom-20 right-20 text-secondary-300 w-24 h-24" />
        <GiTooth className="absolute top-1/2 left-1/4 text-primary-200 w-16 h-16" />
        <GiTooth className="absolute bottom-1/4 right-1/4 text-secondary-200 w-20 h-20" />
      </div>

      <div className="container-custom relative z-10">
        <div className="text-center max-w-4xl mx-auto" data-aos="fade-up">
          <h1 className="text-5xl md:text-7xl font-bold text-gray-800 mb-6">
            Votre sourire
            <span className="text-gradient"> entre des mains expertes</span>
          </h1>

          <p className="text-xl md:text-2xl text-gray-600 mb-8 leading-relaxed">
            Découvrez des soins dentaires de classe mondiale dans un
            environnement moderne et confortable. Notre équipe de professionnels
            expérimentés s'engage à vous fournir la meilleure expérience
            dentaire possible.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
            <button
              onClick={handleSubmit}
              className="btn-primary text-lg px-8 py-4"
            >
              Prendre rendez-vous
            </button>

            <button
              onClick={() =>
                window.open(
                  "https://www.instagram.com/dr.youssef.lachhab/",
                  "_blank"
                )
              }
              className="flex items-center space-x-2 text-gray-600 hover:text-primary-500 transition-colors duration-300"
            >
              <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-lg">
                <FaInstagram className="text-primary-500 ml-1" />
              </div>
              <span className="font-medium">Notre Instagram</span>
            </button>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce-slow">
        <button
          onClick={() =>
            document
              .getElementById("about")
              .scrollIntoView({ behavior: "smooth" })
          }
          className="text-gray-400 hover:text-primary-500 transition-colors duration-300"
        >
          <FaArrowDown size={24} />
        </button>
      </div>
    </section>
  );
};

export default Hero; 